import { InputRule } from 'prosemirror-inputrules';
import { MarkSpec, NodeSpec } from 'prosemirror-model';
import { Command, Plugin } from 'prosemirror-state';
import { Extensions, Marks, Nodes } from '../../constants';
import { CommandProps, InputRulesProps, PluginProps } from '../../types';

export class Extension<Spec = void | NodeSpec | MarkSpec> {
  constructor(
    public readonly name: Nodes | Marks | Extensions,
    public readonly type: 'node' | 'mark' | 'extension' = 'extension'
  ) {}

  get schema(): Spec {
    throw new Error('Not implemented');
  }

  plugins(_pluginProps: PluginProps): Plugin[] {
    return [];
  }

  inputRules(_inputRulesProps: InputRulesProps): InputRule[] {
    return [];
  }

  commands(_commandProps: CommandProps): Record<string, Command> {
    return {};
  }
}
